import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ServiceSidebar from '../components/layout/ServiceSidebar';
import ModernHeader from '../components/layout/ModernHeader';
import DynamicDashboard from '../pages/DynamicDashboard';
import UserDashboard from '../pages/UserDashboard';
import MasterDashboard from '../pages/super/dashboard/MasterDashboard';
import Users from '../pages/super/users/Users';
import Entities from '../pages/super/dlt/Entities';
import Headers from '../pages/super/dlt/Headers';
import Templates from '../pages/super/dlt/Templates';
import AdminTemplateAnalytics from '../pages/admin/TemplateAnalytics';
import Plans from '../pages/super/plans/Plans';
// HTTP Routing removed — SMPP-only architecture
import Recharge from '../pages/super/recharge/Recharge';
import RateManagement from '../pages/super/rate-management/RateManagement';
import ReportsDetailed from '../pages/super/report/Detailed';
import ReportsSummary from '../pages/super/report/Summary';
import ReportsDLR from '../pages/super/report/DLR';
import Settings from '../pages/super/settings/Settings';
import SMPPMonitoring from '../pages/SMPPMonitoring';
import SMPPTLVMappings from '../pages/SMPPTLVMappings';
import AdvancedRoutingManagement from '../pages/admin/AdvancedRoutingManagement';
import RoutingPolicyManagement from '../pages/admin/RoutingPolicyManagement';
import TestSMS from '../pages/admin/TestSMS';
import RoleManagement from '../pages/super/role/Roles';
import UserRoles from '../pages/super/role/UserRoles';
import Permissions from '../pages/super/role/Permissions';
import DashboardGridManager from '../pages/super/role/DashboardConfig';
import WidgetLibrary from '../pages/super/role/WidgetLibrary';
import KafkaStatus from '../pages/master-admin/KafkaStatus';
import KafkaSMSPipeline from '../pages/master-admin/KafkaSMSPipeline';
import MaskingManagement from '../pages/master-admin/MaskingManagement';
import SMPPManagement from '../pages/master-admin/SMPPManagement';
import SMPPInboundAccounts from '../pages/master-admin/SMPPInboundAccounts';
import SMPPTPSControl from '../pages/master-admin/SMPPTPSControl';
import SMPPDLRMonitoring from '../pages/master-admin/SMPPDLRMonitoring';
import SMPPLogs from '../pages/master-admin/SMPPLogs';
import SMPPMetricsDashboard from '../pages/master-admin/SMPPMetricsDashboard';
import SMPPAuditDashboard from '../pages/master-admin/SMPPAuditDashboard';
import SMPPRoutingEngine from '../pages/master-admin/SMPPRoutingEngine';
import DevMonitor from '../pages/DevMonitor';
import SMSTrace from '../pages/master-admin/SMSTrace';
import SMSStatusManager from '../pages/master-admin/SMSStatusManager';
import SMSPipelineManager from '../pages/master-admin/SMSPipelineManager';
// New consolidated SMPP components
import ServerConnections from '../pages/super/smpp/ServerConnections';
// Telegram Alerts
import TelegramAlerts from '../pages/super/alerts/TelegramAlerts';
// Global Settings
import GlobalSettings from '../pages/admin/GlobalSettings';
import KeywordBlocking from '../pages/admin/global-settings/KeywordBlocking';
import MobileBlocking from '../pages/admin/global-settings/MobileBlocking';
import SenderIDBlocking from '../pages/admin/global-settings/SenderIDBlocking';
// Database Tables
import DatabaseTables from '../pages/admin/database-tables/index';
// Worker Management
import WorkerManagement from '../pages/admin/WorkerManagement';
// Font Sample Page
import FontSamplePage from '../pages/admin/FontSamplePage';
import WorkerDashboard from '../pages/admin/WorkerDashboard';
import WorkerConfiguration from '../pages/admin/WorkerConfiguration';
import WorkerLogs from '../pages/admin/WorkerLogs';
// System Flow Documentation Pages
import SystemFlowIndex from '../pages/system-flow/SystemFlowIndex';
import ArchitectureOverview from '../pages/system-flow/ArchitectureOverview';
import MicroservicesDetail from '../pages/system-flow/MicroservicesDetail';
import SMSFlowDiagram from '../pages/system-flow/SMSFlowDiagram';
import DatabaseSchema from '../pages/system-flow/DatabaseSchema';
import AuthenticationFlow from '../pages/system-flow/AuthenticationFlow';
import APIReference from '../pages/system-flow/APIReference';
// Help & Support Pages
import KnowledgeBase from '../pages/help/KnowledgeBase';
import AdminSupportDashboard from '../pages/support/AdminSupportDashboard';
import MessengerStyleSupport from '../components/support/MessengerStyleSupport';
import SystemStatus from '../pages/admin/SystemStatus';
import PlatformChangelog from '../pages/help/PlatformChangelog';
import KeyboardShortcuts from '../pages/help/KeyboardShortcuts';
// Knowledge Base
import KnowledgeBaseList from '../pages/knowledge-base/KnowledgeBaseList';
import KnowledgeBaseArticle from '../pages/knowledge-base/KnowledgeBaseArticle';
import KnowledgeBaseEditor from '../pages/admin/knowledge-base/KnowledgeBaseEditor';
import KnowledgeBaseAnalytics from '../pages/admin/knowledge-base/KnowledgeBaseAnalytics';
import PageWithFooter from '../components/common/PageWithFooter';
// Migration Pages
import MigrateUsersPage from '../pages/admin/migration/MigrateUsersPage';
import MigrateTemplatesPage from '../pages/admin/migration/MigrateTemplatesPage';
import MigrateRechargeHistoryPage from '../pages/admin/migration/MigrateRechargeHistoryPage';
import MigrateSMSSummaryPage from '../pages/admin/migration/MigrateSMSSummaryPage';
import SmsSummaryFetchPage from '../pages/admin/migration/SmsSummaryFetchPage';
import MigrationLogsPage from '../pages/admin/migration/MigrationLogsPage';
// Report Pages
import RuntimeCountDemo from '../pages/admin/reports/RuntimeCountDemo';
import UserMonthlySMSReport from '../pages/admin/reports/UserMonthlySMSReport';
import MonthlyDailyCount from '../pages/admin/reports/MonthlyDailyCount';
// Intelligent Routing Pages
import RoutingIntelligence from '../components/admin/RoutingIntelligence';
import AutoTuning from '../components/admin/AutoTuning';
// PE-TM Chain Management
import PEChainManagement from '../components/admin/PEChainManagementEnhanced';
// Live Bind Monitor
import LiveBindMonitor from '../components/admin/LiveBindMonitorEnhanced';
// SLA & Cost Dashboard
import SlaCostDashboard from '../components/admin/SlaCostDashboard';
// Message Trace
import MessageTrace from '../components/admin/MessageTrace';
// Login Alert Management
import LoginAlertManagement from '../pages/super/users/LoginAlertManagement';
// User CRM Dashboard
import UserCRMDashboard from '../pages/admin/UserCRMDashboard';
import UserCRMNew from '../pages/admin/UserCRMNew';
// Alert Management
import AlertManagementAdmin from '../pages/master-admin/AlertManagement';
// Email Accounts & IP Whitelist Admin
import EmailAccounts from '../pages/master-admin/EmailAccounts';
import IPWhitelistAdmin from '../pages/master-admin/IPWhitelistAdmin';
import EmailTemplateManagement from '../pages/master-admin/EmailTemplateManagement';
import SMSTemplateManagement from '../pages/master-admin/SMSTemplateManagement';
import SendSMS from '../pages/SendSMS';
import SendSMSNew from '../pages/SendSMSNew';
import SendSMSPro from '../pages/SendSMSPro';
import AdminSendSMSNew from '../pages/admin/AdminSendSMSNew';
import DLRSummaryCron from '../pages/master-admin/DLRSummaryCron';
import SMPPErrorCodeMapping from '../pages/master-admin/SMPPErrorCodeMapping';
// WhatsApp Business Pages (Admin)
import WABAManagement from '../pages/admin/whatsapp/WABAManagement';
import WACampaignAdmin from '../pages/admin/whatsapp/WACampaignAdmin';
import WATemplateAdmin from '../pages/admin/whatsapp/WATemplateAdmin';
import WAChatAdmin from '../pages/admin/whatsapp/WAChatAdmin';
import WAReportsAdmin from '../pages/admin/whatsapp/WAReportsAdmin';
import WAAutomationAdmin from '../pages/admin/whatsapp/WAAutomationAdmin';
import WAWebhookConfig from '../pages/admin/whatsapp/WAWebhookConfig';
// Google RCS & Bulk Email (Coming Soon)
import RCSComingSoon from '../pages/rcs/RCSComingSoon';
import EmailComingSoon from '../pages/email/EmailComingSoon';
// Global Pages
import GlobalAPIManagement from '../pages/global/GlobalAPIManagement';
import GlobalSettingsPage from '../pages/global/GlobalSettingsPage';
import ContactBook from '../pages/ContactBook';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [title, setTitle] = useState('');
  const globalSearchRef = useRef(null);

  // F2 keyboard shortcut to open global search
  useEffect(() => {
    const handleKeyDown = (e) => {
      // F2 always opens global search regardless of focus context
      if (e.key === 'F2') {
        e.preventDefault();
        
        // Only open if user has access to global search (Master Admin)
        if (user?.role === 'master_admin' && globalSearchRef.current && globalSearchRef.current.focus) {
          globalSearchRef.current.focus();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [user]);

  // Service-based navigation with super main menus
  const serviceNavigation = [
    // Dashboard — top-level link (common for all services)
    { key: 'dashboard', type: 'link', name: 'Dashboard', href: '/', icon: 'LayoutDashboard', themeKey: 'global' },

    // ═══════════════════════════════════════════════
    // MESSAGING (Indigo/Cyan — current brand colors)
    // ═══════════════════════════════════════════════
    {
      key: 'messaging',
      name: 'Messaging',
      icon: 'MessageSquare',
      themeKey: 'messaging',
      items: [
        {
          name: 'Send SMS',
          icon: 'Send',
          menuKey: 'msg-sendsms',
          children: [
            { name: 'Quick Send', href: '/send-sms', icon: 'Send' },
            { name: 'Advanced', href: '/send-sms-new', icon: 'Sparkles' },
            { name: 'Pro', href: '/send-sms-pro', icon: 'Zap' },
            { name: 'Admin Send', href: '/super/send-sms-new', icon: 'Shield' },
          ]
        },
        {
          name: 'DLT',
          icon: 'FileCheck',
          menuKey: 'msg-dlt',
          children: [
            { name: 'Entities', href: '/super/dlt/entities', icon: 'Building2' },
            { name: 'Headers', href: '/super/dlt/headers', icon: 'Heading' },
            { name: 'Templates', href: '/super/dlt/templates', icon: 'FileText' },
            { name: 'Template Analytics', href: '/super/dlt/template-analytics', icon: 'BarChart3' },
          ]
        },
        {
          name: 'Reports',
          icon: 'BarChart3',
          menuKey: 'msg-reports',
          children: [
            { name: 'Detailed', href: '/super/report/detailed', icon: 'FileText' },
            { name: 'Summary', href: '/super/report/summary', icon: 'BarChart3' },
            { name: 'DLR', href: '/super/report/dlr', icon: 'CheckCircle' },
            { name: 'DLR Summary Cron', href: '/master-admin/dlr-summary-cron', icon: 'Database' },
          ]
        },
        { name: 'Plans', href: '/super/plans', icon: 'Package' },
      ],
    },

    // ═══════════════════════════════════════════════
    // WHATSAPP BUSINESS (WhatsApp green)
    // ═══════════════════════════════════════════════
    {
      key: 'whatsapp',
      name: 'WhatsApp Business',
      icon: 'MessageCircle',
      themeKey: 'whatsapp',
      items: [
        { name: 'WABA Accounts', href: '/wa/admin/waba', icon: 'Building2' },
        { name: 'Campaigns', href: '/wa/admin/campaigns', icon: 'Megaphone' },
        { name: 'Templates', href: '/wa/admin/templates', icon: 'FileText' },
        { name: 'Chat Management', href: '/wa/admin/chat', icon: 'Headphones' },
        {
          name: 'Reports',
          icon: 'BarChart3',
          menuKey: 'wa-reports',
          children: [
            { name: 'All Reports', href: '/wa/admin/reports', icon: 'BarChart3' },
          ]
        },
        { name: 'Automation', href: '/wa/admin/automation', icon: 'Workflow' },
        { name: 'Webhook & Events', href: '/wa/admin/webhooks', icon: 'Globe' },
      ],
    },

    // ═══════════════════════════════════════════════
    // GOOGLE RCS (Google blue/green)
    // ═══════════════════════════════════════════════
    {
      key: 'rcs',
      name: 'Google RCS',
      icon: 'Smartphone',
      themeKey: 'rcs',
      comingSoon: true,
      items: [
        { name: 'RCS Messaging', href: '/rcs/coming-soon', icon: 'Smartphone' },
      ],
    },

    // ═══════════════════════════════════════════════
    // BULK EMAIL (Yellow/Amber)
    // ═══════════════════════════════════════════════
    {
      key: 'email',
      name: 'Bulk Email',
      icon: 'Mail',
      themeKey: 'email',
      comingSoon: true,
      items: [
        { name: 'Email Campaigns', href: '/email/coming-soon', icon: 'Mail' },
      ],
    },

    // ═══════════════════════════════════════════════
    // API MANAGEMENT (Global — serves all services)
    // ═══════════════════════════════════════════════
    // CONTACT BOOK
    { key: 'contact-book', type: 'link', name: 'Contact Book', href: '/contact-book', icon: 'BookUser', themeKey: 'global' },

    { key: 'api-management', type: 'link', name: 'API Management', href: '/global/api-management', icon: 'Code2', themeKey: 'global' },

    // ═══════════════════════════════════════════════
    // GLOBAL SETTINGS (Global — merged: Profile, Alerts, Recipients, IP Whitelist, Balance)
    // ═══════════════════════════════════════════════
    { key: 'global-settings', type: 'link', name: 'Settings', href: '/global/settings', icon: 'Settings', themeKey: 'global' },

    // ═══════════════════════════════════════════════
    // ADMIN-ONLY SECTIONS (Master Admin)
    // ═══════════════════════════════════════════════
    ...(user?.role === 'master_admin' || user?.role === 'admin' ? [{
      key: 'admin-tools',
      name: 'Administration',
      icon: 'ShieldCheck',
      themeKey: 'global',
      items: [
        {
          name: 'Users',
          icon: 'Users',
          menuKey: 'adm-users',
          children: [
            { name: 'User CRM', href: '/admin/user-crm', icon: 'Contact' },
            { name: 'User CRM New', href: '/admin/user-crm-new', icon: 'LayoutDashboard' },
            { name: 'User List', href: '/super/users', icon: 'Users' },
            { name: 'Login Alerts', href: '/super/users/login-alerts', icon: 'ShieldAlert' },
            { name: 'Content Masking', href: '/master-admin/masking', icon: 'FingerprintPattern' },
            { name: 'Alert Management', href: '/master-admin/alert-management', icon: 'BellRing' },
            { name: 'Rate Management', href: '/super/rate-management', icon: 'BadgeDollarSign' },
            { name: 'Recharge', href: '/super/recharge', icon: 'Wallet' },
          ]
        },
        {
          name: 'Role Management',
          icon: 'Shield',
          menuKey: 'adm-roles',
          children: [
            { name: 'Roles', href: '/super/role/roles', icon: 'ShieldCheck' },
            { name: 'User Roles', href: '/super/role/user-roles', icon: 'UserCog' },
            { name: 'Permissions', href: '/super/role/permissions', icon: 'Key' },
            { name: 'Dashboard Config', href: '/super/role/dashboard-config', icon: 'Settings2' },
            { name: 'Widget Library', href: '/super/role/widget-library', icon: 'Box' },
          ]
        },
        {
          name: 'Global Settings',
          icon: 'Globe',
          menuKey: 'adm-global-settings',
          children: [
            { name: 'PE-TM Chain Management', href: '/admin/compliance/pe-tm-chains', icon: 'Lock' },
            { name: 'Telegram Alerts', href: '/super/alerts/telegram', icon: 'Bell' },
            { name: 'Keyword Blocking', href: '/admin/global-settings/keyword-blocking', icon: 'Shield' },
            { name: 'Mobile Blocking', href: '/admin/global-settings/mobile-blocking', icon: 'PhoneOff' },
            { name: 'Sender ID Blocking', href: '/admin/global-settings/sender-id-blocking', icon: 'Ban' },
            { name: 'Database Tables', href: '/admin/database-tables', icon: 'Table' },
          ]
        },
        {
          name: 'Routing',
          icon: 'Route',
          menuKey: 'adm-routing',
          children: [
            { name: 'Routing Policies', href: '/admin/routing-policies', icon: 'Route' },
            { name: 'Legacy Routes', href: '/super/smpp/routes', icon: 'Settings' },
            { name: 'Auto Tuning & ML', href: '/admin/auto-tuning', icon: 'Brain' },
          ]
        },
        { name: 'Old Settings', href: '/super/settings', icon: 'Settings' },
      ],
    }] : []),

    ...(user?.role === 'master_admin' ? [{
      key: 'smpp-mgmt',
      name: 'SMPP Management',
      icon: 'Server',
      themeKey: 'messaging',
      items: [
        { name: 'Overview', href: '/super/smpp', icon: 'LayoutDashboard' },
        {
          name: 'Connections',
          icon: 'Cable',
          menuKey: 'smpp-conn',
          children: [
            { name: 'Outbound Accounts', href: '/super/smpp/connections', icon: 'Cable' },
            { name: 'Inbound Accounts', href: '/super/smpp/inbound-accounts', icon: 'Users' },
            { name: 'Live Bind Monitor', href: '/admin/smpp/live-binds', icon: 'Activity' },
          ]
        },
        {
          name: 'Routing',
          icon: 'Route',
          menuKey: 'smpp-routing',
          children: [
            { name: 'Routing Policies', href: '/admin/routing-policies', icon: 'Route' },
            { name: 'Legacy Routes', href: '/super/smpp/routes', icon: 'Settings' },
            { name: 'Routing Engine', href: '/super/smpp/routing-engine', icon: 'Settings' },
          ]
        },
        {
          name: 'Monitoring',
          icon: 'Activity',
          menuKey: 'smpp-monitoring',
          children: [
            { name: 'TPS Control', href: '/super/smpp/tps-control', icon: 'Gauge' },
            { name: 'DLR Monitoring', href: '/super/smpp/dlr-monitoring', icon: 'Activity' },
            { name: 'SLA & Cost', href: '/admin/smpp/sla-cost', icon: 'TrendingUp' },
            { name: 'Message Trace', href: '/admin/smpp/trace', icon: 'Search' },
            { name: 'Logs', href: '/super/smpp/logs', icon: 'FileText' },
            { name: 'Audit Dashboard', href: '/super/smpp/audit', icon: 'Shield' },
            { name: 'Metrics', href: '/super/smpp/metrics', icon: 'TrendingUp' },
            { name: 'Error Codes', href: '/super/smpp/error-codes', icon: 'Shield' },
            { name: 'SMS Status Manager', href: '/super/sms-status', icon: 'Settings' },
            { name: 'SMS Pipeline Manager', href: '/super/sms-pipeline', icon: 'Activity' },
          ]
        },
      ],
    }] : []),

    ...(user?.role === 'master_admin' ? [{
      key: 'platform-ops',
      name: 'Platform Operations',
      icon: 'Cpu',
      themeKey: 'global',
      items: [
        {
          name: 'Platform Config',
          icon: 'Settings2',
          menuKey: 'ops-platform',
          children: [
            { name: 'Email Accounts', href: '/master-admin/email-accounts', icon: 'Mail' },
            { name: 'Email Templates', href: '/master-admin/email-templates', icon: 'FileText' },
            { name: 'SMS Templates', href: '/master-admin/sms-templates', icon: 'MessageSquare' },
            { name: 'IP Whitelist', href: '/master-admin/ip-whitelist', icon: 'ShieldCheck' },
          ]
        },
        {
          name: 'Monitoring',
          icon: 'Activity',
          menuKey: 'ops-monitoring',
          children: [
            { name: 'Kafka Status', href: '/master-admin/kafka-status', icon: 'RefreshCw' },
            { name: 'Dev Monitor', href: '/master-admin/dev-monitor', icon: 'Wrench' },
            { name: 'SMS Trace Debug', href: '/master-admin/sms-trace', icon: 'Search' },
          ]
        },
        {
          name: 'Worker Management',
          icon: 'Cpu',
          menuKey: 'ops-workers',
          children: [
            { name: 'Dashboard', href: '/admin/worker-dashboard', icon: 'LayoutDashboard' },
            { name: 'Management', href: '/admin/worker-management', icon: 'Users' },
            { name: 'Configuration', href: '/admin/worker-configuration', icon: 'Settings' },
            { name: 'Logs', href: '/admin/worker-logs', icon: 'FileText' },
          ]
        },
        { name: 'Font Samples', href: '/admin/font-samples', icon: 'Type' },
        {
          name: 'Archive & Migration',
          icon: 'Archive',
          menuKey: 'ops-archive',
          children: [
            { name: 'Runtime Count', href: '/admin/reports/runtime-count', icon: 'Calculator' },
            { name: 'Monthly SMS Report', href: '/admin/reports/monthly-sms', icon: 'Calendar' },
            { name: 'Daily Count', href: '/admin/reports/monthly-daily-count', icon: 'BarChart3' },
            { name: 'Migrate Users', href: '/admin/migration/users', icon: 'Users' },
            { name: 'Migrate Templates', href: '/admin/migration/templates', icon: 'FileText' },
            { name: 'Migration Logs', href: '/admin/migration/logs', icon: 'FileText' },
          ]
        },
        {
          name: 'System Flow',
          icon: 'BookOpen',
          menuKey: 'ops-sysflow',
          children: [
            { name: 'Overview', href: '/system-flow', icon: 'LayoutDashboard' },
            { name: 'Architecture', href: '/system-flow/architecture', icon: 'Server' },
            { name: 'SMS Flow', href: '/system-flow/sms-flow', icon: 'Send' },
            { name: 'Microservices', href: '/system-flow/microservices', icon: 'Cpu' },
            { name: 'Database Schema', href: '/system-flow/databases', icon: 'Database' },
            { name: 'Authentication', href: '/system-flow/authentication', icon: 'Shield' },
            { name: 'API Reference', href: '/system-flow/api-reference', icon: 'Code' },
          ]
        },
      ],
    }] : []),
  ];


  return (
    <div className="h-screen flex flex-col overflow-hidden print-root" style={{
      background: '#f8f9fb',
    }}>
      {/* Global Design System + Print Styles */}
      <style>{`
        /* Design System — matching login page brand */
        :root {
          --w2c-primary: #4f46e5;
          --w2c-primary-light: rgba(99, 102, 241, 0.06);
          --w2c-accent: #06b6d4;
          --w2c-gradient: linear-gradient(135deg, #4f46e5 0%, #06b6d4 100%);
          --w2c-gradient-soft: linear-gradient(135deg, rgba(99, 102, 241, 0.06) 0%, rgba(6, 182, 212, 0.04) 100%);
          --w2c-border: rgba(99, 102, 241, 0.06);
          --w2c-shadow: 0 1px 2px rgba(99, 102, 241, 0.04), 0 2px 8px rgba(99, 102, 241, 0.03);
          --w2c-shadow-hover: 0 4px 12px rgba(99, 102, 241, 0.08), 0 8px 24px rgba(99, 102, 241, 0.04);
          --w2c-radius: 10px;
          --w2c-radius-lg: 14px;
        }

        /* Scrollbar styling */
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: rgba(99, 102, 241, 0.12); border-radius: 10px; }
        ::-webkit-scrollbar-thumb:hover { background: rgba(99, 102, 241, 0.2); }

        /* Print Styles */
        @media print {
          body { background: white !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .print-hide-header, .print-hide-sidebar, .print-hide-footer { display: none !important; }
          .print-content-area {
            margin-left: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
            height: auto !important;
          }
          .print-content-wrapper {
            padding-top: 0 !important;
            overflow: visible !important;
            height: auto !important;
          }
          .print-root {
            overflow: visible !important;
            height: auto !important;
          }
        }
      `}</style>
      {/* Fixed Header */}
      <div className="print-hide-header">
        <ModernHeader
          setSidebarOpen={setSidebarOpen}
          user={user}
          title={title}
          globalSearchRef={globalSearchRef}
          logout={logout}
        />
      </div>

      {/* Sidebar + Content Row */}
      <div className="flex flex-1 overflow-hidden print-content-wrapper" style={{ paddingTop: '62px' }}>
        <div className="print-hide-sidebar">
          <ServiceSidebar
            serviceNavigation={serviceNavigation}
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            user={user}
            logout={logout}
          />
        </div>

        {/* Scrollable Content Area */}
        <main className="flex-1 overflow-y-auto print-content-area" style={{ paddingLeft: '0' }}>
          <div className="lg:ml-[256px] p-5 lg:p-6 max-w-full mx-auto print-content-area">
            <Routes>
            <Route path="/" element={<PageWithFooter>{(user?.role === 'master_admin' || user?.role === 'MASTER_ADMIN') ? <MasterDashboard /> : <UserDashboard />}</PageWithFooter>} />
            <Route path="/admin/user-crm" element={<PageWithFooter><UserCRMDashboard /></PageWithFooter>} />
            <Route path="/admin/user-crm-new" element={<PageWithFooter><UserCRMNew /></PageWithFooter>} />
            <Route path="/super/users" element={<PageWithFooter><Users /></PageWithFooter>} />
            <Route path="/super/users/login-alerts" element={<PageWithFooter><LoginAlertManagement /></PageWithFooter>} />
            <Route path="/master-admin/alert-management" element={<PageWithFooter><AlertManagementAdmin /></PageWithFooter>} />
            <Route path="/user/alert-management" element={<Navigate to="/global/settings" replace />} />
            <Route path="/super/dlt/entities" element={<PageWithFooter><Entities /></PageWithFooter>} />
            <Route path="/super/dlt/headers" element={<PageWithFooter><Headers /></PageWithFooter>} />
            <Route path="/super/dlt/templates" element={<PageWithFooter><Templates /></PageWithFooter>} />
            <Route path="/super/dlt/template-analytics" element={<PageWithFooter><AdminTemplateAnalytics /></PageWithFooter>} />
            <Route path="/send-sms" element={<PageWithFooter><SendSMS /></PageWithFooter>} />
            <Route path="/send-sms-new" element={<PageWithFooter><SendSMSNew /></PageWithFooter>} />
            <Route path="/send-sms-pro" element={<PageWithFooter><SendSMSPro /></PageWithFooter>} />
            <Route path="/super/send-sms-new" element={<PageWithFooter><AdminSendSMSNew /></PageWithFooter>} />
            <Route path="/master-admin/dlr-summary-cron" element={<PageWithFooter><DLRSummaryCron /></PageWithFooter>} />
            <Route path="/super/plans" element={<PageWithFooter><Plans /></PageWithFooter>} />
            <Route path="/super/recharge" element={<PageWithFooter><Recharge /></PageWithFooter>} />
            <Route path="/super/rate-management" element={<PageWithFooter><RateManagement /></PageWithFooter>} />
            {/* PROMPT-092: Super module report routes */}
            <Route path="/super/report/detailed" element={<PageWithFooter><ReportsDetailed /></PageWithFooter>} />
            <Route path="/super/report/summary" element={<PageWithFooter><ReportsSummary /></PageWithFooter>} />
            <Route path="/super/report/dlr" element={<PageWithFooter><ReportsDLR /></PageWithFooter>} />
            <Route path="/super/role/roles" element={<PageWithFooter><RoleManagement /></PageWithFooter>} />
            <Route path="/super/role/user-roles" element={<PageWithFooter><UserRoles /></PageWithFooter>} />
            <Route path="/super/role/permissions" element={<PageWithFooter><Permissions /></PageWithFooter>} />
            <Route path="/super/role/dashboard-config" element={<PageWithFooter><DashboardGridManager /></PageWithFooter>} />
            <Route path="/super/role/widget-library" element={<PageWithFooter><WidgetLibrary /></PageWithFooter>} />
            <Route path="/master-admin/masking" element={<PageWithFooter><MaskingManagement /></PageWithFooter>} />
            <Route path="/master-admin/kafka-status" element={<PageWithFooter><KafkaStatus /></PageWithFooter>} />
            <Route path="/master-admin/kafka-sms-pipeline" element={<PageWithFooter><KafkaSMSPipeline /></PageWithFooter>} />
            <Route path="/master-admin/dev-monitor" element={<PageWithFooter><DevMonitor /></PageWithFooter>} />
            {/* PROMPT-101: SMPP Management Routes (Master Admin Only) */}
            <Route path="/super/smpp" element={<PageWithFooter><SMPPManagement /></PageWithFooter>} />
            <Route path="/super/smpp/connections" element={<PageWithFooter><ServerConnections /></PageWithFooter>} />
            <Route path="/super/smpp/inbound-accounts" element={<PageWithFooter><SMPPInboundAccounts /></PageWithFooter>} />
            <Route path="/super/smpp/routes" element={<PageWithFooter><AdvancedRoutingManagement /></PageWithFooter>} />
            <Route path="/super/smpp/routing-engine" element={<PageWithFooter><SMPPRoutingEngine /></PageWithFooter>} />
            <Route path="/super/smpp/tps-control" element={<PageWithFooter><SMPPTPSControl /></PageWithFooter>} />
            <Route path="/super/smpp/dlr-monitoring" element={<PageWithFooter><SMPPDLRMonitoring /></PageWithFooter>} />
            <Route path="/super/smpp/logs" element={<PageWithFooter><SMPPLogs /></PageWithFooter>} />
            <Route path="/super/smpp/metrics" element={<PageWithFooter><SMPPMetricsDashboard /></PageWithFooter>} />
            <Route path="/super/smpp/audit" element={<PageWithFooter><SMPPAuditDashboard /></PageWithFooter>} />
            <Route path="/super/smpp/error-codes" element={<PageWithFooter><SMPPErrorCodeMapping /></PageWithFooter>} />
            <Route path="/super/sms-status" element={<PageWithFooter><SMSStatusManager /></PageWithFooter>} />
            <Route path="/super/sms-pipeline" element={<PageWithFooter><SMSPipelineManager /></PageWithFooter>} />
            <Route path="/master-admin/sms-trace" element={<PageWithFooter><SMSTrace /></PageWithFooter>} />
            {/* Email Accounts & IP Whitelist Admin */}
            <Route path="/master-admin/email-accounts" element={<PageWithFooter><EmailAccounts /></PageWithFooter>} />
            <Route path="/master-admin/ip-whitelist" element={<PageWithFooter><IPWhitelistAdmin /></PageWithFooter>} />
            <Route path="/master-admin/email-templates" element={<PageWithFooter><EmailTemplateManagement /></PageWithFooter>} />
            <Route path="/master-admin/sms-templates" element={<PageWithFooter><SMSTemplateManagement /></PageWithFooter>} />
            <Route path="/super/alerts/telegram" element={<PageWithFooter><TelegramAlerts /></PageWithFooter>} />
            <Route path="/super/settings" element={<PageWithFooter><Settings /></PageWithFooter>} />
            {/* Global Settings Routes */}
            <Route path="/admin/global-settings" element={<PageWithFooter><GlobalSettings /></PageWithFooter>} />
            <Route path="/admin/global-settings/keyword-blocking" element={<PageWithFooter><KeywordBlocking /></PageWithFooter>} />
            <Route path="/admin/global-settings/mobile-blocking" element={<PageWithFooter><MobileBlocking /></PageWithFooter>} />
            <Route path="/admin/global-settings/sender-id-blocking" element={<PageWithFooter><SenderIDBlocking /></PageWithFooter>} />
            {/* Database Tables */}
            <Route path="/admin/database-tables" element={<DatabaseTables />} />
            
            {/* Knowledge Base */}
            <Route path="/knowledge-base" element={<KnowledgeBaseList />} />
            <Route path="/knowledge-base/article/:id" element={<KnowledgeBaseArticle />} />
            <Route path="/admin/knowledge-base" element={<KnowledgeBaseList />} />
            <Route path="/admin/knowledge-base/create" element={<KnowledgeBaseEditor />} />
            <Route path="/admin/knowledge-base/edit/:id" element={<KnowledgeBaseEditor />} />
            <Route path="/admin/knowledge-base/analytics" element={<KnowledgeBaseAnalytics />} />
            
            {/* Worker Management */}
            <Route path="/admin/worker-management" element={<WorkerManagement />} />
            {/* Font Sample Page */}
            <Route path="/admin/font-samples" element={<PageWithFooter><FontSamplePage /></PageWithFooter>} />
            <Route path="/admin/worker-dashboard" element={<WorkerDashboard />} />
            <Route path="/admin/worker-configuration" element={<WorkerConfiguration />} />
            <Route path="/admin/worker-logs" element={<WorkerLogs />} />
            
            {/* Migration Routes */}
            <Route path="/admin/migration/users" element={<PageWithFooter><MigrateUsersPage /></PageWithFooter>} />
            <Route path="/admin/migration/templates" element={<PageWithFooter><MigrateTemplatesPage /></PageWithFooter>} />
            <Route path="/admin/migration/recharge-history" element={<PageWithFooter><MigrateRechargeHistoryPage /></PageWithFooter>} />
            <Route path="/admin/migration/sms-summary" element={<PageWithFooter><MigrateSMSSummaryPage /></PageWithFooter>} />
            <Route path="/admin/migration/sms-summary-fetch" element={<PageWithFooter><SmsSummaryFetchPage /></PageWithFooter>} />
            <Route path="/admin/migration/logs" element={<PageWithFooter><MigrationLogsPage /></PageWithFooter>} />
            {/* Report Routes */}
            <Route path="/admin/reports/runtime-count" element={<PageWithFooter><RuntimeCountDemo /></PageWithFooter>} />
            <Route path="/admin/reports/monthly-sms" element={<PageWithFooter><UserMonthlySMSReport /></PageWithFooter>} />
            <Route path="/admin/reports/monthly-daily-count" element={<PageWithFooter><MonthlyDailyCount /></PageWithFooter>} />
            <Route path="/admin/routing-policies" element={<PageWithFooter><RoutingPolicyManagement /></PageWithFooter>} />
            <Route path="/admin/routing" element={<PageWithFooter><RoutingIntelligence /></PageWithFooter>} />
            <Route path="/admin/auto-tuning" element={<PageWithFooter><AutoTuning /></PageWithFooter>} />
            <Route path="/admin/compliance/pe-tm-chains" element={<PageWithFooter><PEChainManagement /></PageWithFooter>} />
            <Route path="/admin/smpp/live-binds" element={<PageWithFooter><LiveBindMonitor /></PageWithFooter>} />
            <Route path="/admin/smpp/sla-cost" element={<PageWithFooter><SlaCostDashboard /></PageWithFooter>} />
            <Route path="/admin/smpp/trace" element={<PageWithFooter><MessageTrace /></PageWithFooter>} />
            {/* System Flow Documentation Routes */}
            <Route path="/system-flow" element={<PageWithFooter><SystemFlowIndex /></PageWithFooter>} />
            <Route path="/system-flow/architecture" element={<PageWithFooter><ArchitectureOverview /></PageWithFooter>} />
            <Route path="/system-flow/sms-flow" element={<PageWithFooter><SMSFlowDiagram /></PageWithFooter>} />
            <Route path="/system-flow/microservices" element={<PageWithFooter><MicroservicesDetail /></PageWithFooter>} />
            <Route path="/system-flow/databases" element={<PageWithFooter><DatabaseSchema /></PageWithFooter>} />
            <Route path="/system-flow/authentication" element={<PageWithFooter><AuthenticationFlow /></PageWithFooter>} />
            <Route path="/system-flow/api-reference" element={<PageWithFooter><APIReference /></PageWithFooter>} />
            {/* WhatsApp Business Admin Routes */}
            <Route path="/wa/admin/waba" element={<PageWithFooter><WABAManagement /></PageWithFooter>} />
            <Route path="/wa/admin/campaigns" element={<PageWithFooter><WACampaignAdmin /></PageWithFooter>} />
            <Route path="/wa/admin/templates" element={<PageWithFooter><WATemplateAdmin /></PageWithFooter>} />
            <Route path="/wa/admin/chat" element={<PageWithFooter><WAChatAdmin /></PageWithFooter>} />
            <Route path="/wa/admin/reports" element={<PageWithFooter><WAReportsAdmin /></PageWithFooter>} />
            <Route path="/wa/admin/automation" element={<PageWithFooter><WAAutomationAdmin /></PageWithFooter>} />
            <Route path="/wa/admin/webhooks" element={<PageWithFooter><WAWebhookConfig /></PageWithFooter>} />
            {/* Google RCS & Bulk Email (Coming Soon) */}
            <Route path="/rcs/coming-soon" element={<PageWithFooter><RCSComingSoon /></PageWithFooter>} />
            <Route path="/email/coming-soon" element={<PageWithFooter><EmailComingSoon /></PageWithFooter>} />
            {/* Contact Book */}
            <Route path="/contact-book" element={<PageWithFooter><ContactBook /></PageWithFooter>} />
            {/* Global Pages */}
            <Route path="/global/api-management" element={<PageWithFooter><GlobalAPIManagement /></PageWithFooter>} />
            <Route path="/global/settings" element={<PageWithFooter><GlobalSettingsPage /></PageWithFooter>} />
            {/* Default redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
            {/* Redirect old SMPP routes to new location */}
            <Route path="/super/smpp/connectors" element={<Navigate to="/super/smpp/connections" replace />} />
            <Route path="/smpp/connectors" element={<Navigate to="/super/smpp/connections" replace />} />
            <Route path="/smpp/monitoring" element={<Navigate to="/super/smpp/monitoring" replace />} />
            <Route path="/smpp/connections" element={<Navigate to="/super/smpp/connections" replace />} />
            <Route path="/smpp/tlv-mappings" element={<Navigate to="/super/smpp/tlv-mappings" replace />} />
            <Route path="/smpp/routing" element={<Navigate to="/super/smpp/routes" replace />} />
            <Route path="/smpp/test-sms" element={<Navigate to="/super/smpp/test-sms" replace />} />
            <Route path="/super/smpp/server-connections" element={<Navigate to="/super/smpp/connections" replace />} />
            <Route path="/master-admin/smpp" element={<Navigate to="/super/smpp" replace />} />
            
            {/* Help & Support Routes */}
            <Route path="/knowledge-base" element={<PageWithFooter><KnowledgeBase /></PageWithFooter>} />
            <Route path="/support/dashboard" element={<PageWithFooter><MessengerStyleSupport /></PageWithFooter>} />
            <Route path="/system/status" element={<PageWithFooter><SystemStatus /></PageWithFooter>} />
            <Route path="/changelog" element={<PageWithFooter><PlatformChangelog /></PageWithFooter>} />
            <Route path="/shortcuts" element={<PageWithFooter><KeyboardShortcuts /></PageWithFooter>} />
            
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
